import React from 'react';
import { Button } from 'primereact/button';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { ProgressSpinner } from 'primereact/progressspinner';
import { useMutation } from '@tanstack/react-query';
import { putCompanyStatus } from '../../../services/admin/UsersService';
import { AxiosError } from 'axios';
import { showToast } from '../../../components/messages/ErrorAlert';
import { Toast } from 'primereact/toast';

type ToggleCompanyStatusButtonProps = {
  companyID: string;
  isActive: boolean;
  toastRef: React.RefObject<Toast>;
  afterToggle?: (isActive: boolean) => void;
};

const ToggleCompanyStatusButton = ({
  companyID,
  isActive,
  toastRef,
  afterToggle,
}: ToggleCompanyStatusButtonProps) => {
  const toggleResult = useMutation({
    mutationFn: () => putCompanyStatus(companyID, !isActive),
    onSuccess: () => {
      if (afterToggle) afterToggle(!isActive);
      showToast(
        'success',
        toastRef,
        isActive ? 'Disable Company' : 'Enable Company',
        `Company has been ${isActive ? 'disabled' : 'enabled'} successfully`,
        3000
      );
    },
    onError: (error: AxiosError) => {
      showToast(
        'error',
        toastRef,
        isActive ? 'Disable Company Error' : 'Enable Company Error',
        'An error occurred! please try again later',
        3000
      );
    },
  });

  const onClick = () => {
    confirmDialog({
      message: `Do you want to ${isActive ? 'disable' : 'enable'} this company?`,
      header: `${isActive ? 'Disable' : 'Enable'} Confirmation`,
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: toggleResult.mutate,
    });
  };

  return (
    <div>
      <Button
        onClick={onClick}
        className={`w-15rem border-0 flex py-3 ${isActive ? 'bluwaiRed' : 'bg-green-500'}`}
      >
        {toggleResult.isLoading && (
          <ProgressSpinner className="w-3rem h-3rem" />
        )}
        {!toggleResult.isLoading && (
          <span className="mx-auto text-22px text-white">
            {isActive ? 'Disable' : 'Enable'}
          </span>
        )}
      </Button>
      <ConfirmDialog />
    </div>
  );
};

export default ToggleCompanyStatusButton;
